import {
    getParentCategoryFromSubCategory,
    isSubCategory,
} from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import genericOne from '../../../../static/images/generic/generic_1.jpg';
import { CategoryBrowseHeader } from '../../components/CategoryBrowseHeader';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import { COLOR_MAP, MELLOW } from '../../constants/colorThemes';
import { useSavedTags } from '../../hooks/queries/interests';
import { useLocation } from '../../hooks/queries/location';

interface CategoryBrowseHeaderContainerProps {
    activeCategory: string;
    isAuthenticated: boolean;
}

export const CategoryBrowseHeaderContainer: React.FunctionComponent<
    CategoryBrowseHeaderContainerProps
> = (props) => {
    const { data: locationData } = useLocation();
    const { activeCategory, isAuthenticated } = props;
    const isSubcategory = isSubCategory(activeCategory);
    const [fallbackImage] = React.useState(genericOne);
    const { loading, isSaved, toggleTag } = useSavedTags(
        activeCategory,
        isAuthenticated,
    );

    const headerStaticContent = CATEGORY_CONTENT_MAP[activeCategory];

    //Get color theme for the header
    const theme = headerStaticContent?.theme
        ? headerStaticContent?.theme
        : CATEGORY_CONTENT_MAP[
              getParentCategoryFromSubCategory(headerStaticContent.key)
          ].theme;
    const headerTheme = COLOR_MAP[theme || MELLOW];

    //Get header text content
    const subTitle = gettext(
        'Discover the best %(activeTagName)s events in your area and online',
        { activeTagName: headerStaticContent.title },
    );

    const mainHeader = gettext('%(activeTagName)s events', {
        activeTagName: headerStaticContent.title,
    });
    const titleLocation = locationData?.currentPlaceParent
        ? gettext('in %(city)s, %(region)s', {
              city: locationData?.currentPlace,
              region: locationData?.currentPlaceParent,
          })
        : gettext('in %(city)s', { city: locationData?.currentPlace });

    const subHeader = locationData?.isOnline
        ? gettext('Online')
        : titleLocation;

    return (
        <CategoryBrowseHeader
            {...headerStaticContent}
            title={
                <>
                    {mainHeader}
                    <div
                        className="eds-text-bl"
                        style={{
                            color: headerTheme.secondary,
                            paddingTop: '8px',
                        }}
                    >
                        {subHeader}
                    </div>
                </>
            }
            fallbackTitle={headerStaticContent.title}
            fallbackImage={fallbackImage}
            subtitle={headerStaticContent?.subtitle ? subTitle : ''}
            callToAction={
                isAuthenticated && isSubcategory ? (
                    <Button
                        onClick={() => {
                            trackAnalyticsEvent({
                                category: 'category-page',
                                action: isSaved
                                    ? 'RemoveInterest'
                                    : 'SelectInterest',
                                label: activeCategory,
                            });
                            return toggleTag(isSaved);
                        }}
                        variant="primary"
                        size="responsive"
                        disabled={loading}
                    >
                        {isSaved
                            ? `- ${gettext('Remove from interests')}`
                            : `+ ${gettext('Add to interests')}`}
                    </Button>
                ) : undefined
            }
            theme={headerTheme}
            isRounded={isSubcategory}
        />
    );
};
